import Axios from "axios";
import type { BookingScheduleInterface } from "../../../features/Booking-Form/typings/booking.types";

export type PatchVisitorInformationBody = {
  firstName?: string;
  surname?: string;
  email?: string;
  company?: string;
  contacts?: string;
  visitReason?: string;
};

export type PatchVisitOnlyBookingBody = {
  startDate?: string;
  endDate?: string;
  startTime?: string;
  endTime?: string;
  userBookedFor?: string;
  locationInventoryId?: number;
  bookingInventoryId?: number;
  description?: string;
  visitorInformation?: PatchVisitorInformationBody;
};

export type PatchVisitOnlyBookingVariables = {
  visitId: number;
  body: PatchVisitOnlyBookingBody;
};

/** PATCH visitor registration workplace booking (visit id = place booking id). */
export const patchVisitOnlyBooking = ({ visitId, body }: PatchVisitOnlyBookingVariables) =>
  Axios.patch<BookingScheduleInterface>(`/booking/visit-only/${visitId}`, body);
